<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        Heading,
        SESSION_USER,
        List,
        EmbedVideo,
        Paragraph,
    } from '@smatch/cassiopeia-web-components';

    // PLUGINS
    import { onMount } from 'svelte';
    import { useNavigate } from 'svelte-navigator';

    /* INTERNALS -------------------------------------------------------------------------------- */

    const navigate = useNavigate();

    onMount(() => {
        if ($SESSION_USER === null) {
            navigate('/');
        }
    });

</script>

{#if $SESSION_USER !== null}

    <Heading size = 'xl'>What happens next?</Heading>
    <Heading size = 'md' style = 'subtle'>Relax! This is where we take over.</Heading>

    <EmbedVideo source = 'https://www.loom.com/embed/9b040955d2f04e008eeac04d8ba6420f' css = 'mb-8 mt-4' />

    <List mode = 'numeric'>
        <li>We validate if smatch is a good match for you.</li>
        <li>We will then give you an onboarding call to dive deeper into your requirements.</li>
        <li>
            After our joint call you’ll receive access to exclusive smatch deals.
            You’ll also receive automatic updates, whenever a deal matching your preferences is available.
        </li>
    </List>

    <Paragraph align = 'center' color = 'success'>
        Our team will reach out to you shortly - you can now close the page if you want to.
    </Paragraph>

{/if}

<style lang='postcss'>

</style>